import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/../public/assets/keplr-logo.png'
import _imports_1 from '@/../public/assets/google-logo.svg'
import _imports_2 from '@/../public/assets/twitter-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-55112e00"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "font-lg",
  style: {"text-align":"right","width":"100%","padding-right":"1rem","padding-top":"0.5rem"}
}
const _hoisted_2 = { style: {"display":"flex","flex-direction":"column","align-items":"center","padding-top":"2rem"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "font-md" }, "login or sign up", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "font-lg",
  style: {"color":"rgba(3, 97, 118, 1)","margin-top":"2rem","margin-bottom":"2rem"}
}, " A world of stories awaits! ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { style: {"margin-bottom":"1rem"} }, "Crypto Only", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Keplr logo",
  src: _imports_0
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { style: {"margin-top":"2rem","margin-bottom":"1rem"} }, "Likes, notifications and other features:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Keplr logo",
  src: _imports_0
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Google logo",
  src: _imports_1
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Twitter logo",
  src: _imports_2
}, null, -1))

import {
  IonModal,
  IonButton,
  IonContent,
  IonAvatar,
  IonIcon,
  IonLabel,
} from "@ionic/vue";
import { useAuthStore, useWalletStore, useWeb2AuthStore } from "../store";
import { closeOutline } from "ionicons/icons";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginModal',
  setup(__props) {

const authStore = useAuthStore();
const web2AuthStore = useWeb2AuthStore();
const walletStore = useWalletStore();

const signIn = async (method) => {
  switch (method) {
    case "keplrWeb3":
      await walletStore.logInUser();
      break;
    case "keplrWeb2":
      await web2AuthStore.signInWithKeplr();
      break;
    case "google":
      await web2AuthStore.signInWithGoogle();
      break;
    case "twitter":
      await web2AuthStore.signInWithTwitter();
      break;
  }
  authStore.showSignInModal = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonModal), {
    id: "sign-in-modal",
    "is-open": _unref(authStore).showSignInModal,
    onWillDismiss: _cache[5] || (_cache[5] = ($event: any) => (_unref(authStore).showSignInModal = false)),
    style: {"--height":"100%"}
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { style: {"text-align":"center"} }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(IonIcon), {
              icon: _unref(closeOutline),
              style: {"cursor":"pointer"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(authStore).showSignInModal = false))
            }, null, 8, ["icon"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            _createVNode(_unref(IonButton), {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (signIn('keplrWeb3'))),
              style: {"width":"331px","text-transform":"none"},
              class: "sign-in-button"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonAvatar), null, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode("Connect with Keplr")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_7,
            _createVNode(_unref(IonButton), {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (signIn('keplrWeb2'))),
              style: {"width":"331px","text-transform":"none"},
              class: "sign-in-button"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonAvatar), null, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode("Sign In with Keplr")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonButton), {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (signIn('google'))),
              style: {"width":"331px","text-transform":"none"},
              class: "sign-in-button"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonAvatar), null, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode("Sign In with Google")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonButton), {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (signIn('twitter'))),
              style: {"width":"331px","text-transform":"none"},
              class: "sign-in-button"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonAvatar), null, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode("Sign In with Twitter")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-open"]))
}
}

})